module.exports = __webpack_public_path__ + "static/media/network_hospital.96ba26bf.svg";